import { brandEmail, brandName, friendLinks, navItems } from "@/mocks/gossip";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-2">
            <a href="#top" className="inline-flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
                <i className="ri-fire-fill text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{brandName}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              蹲后续、催更、指路一站式搞定，跟紧大部队一起围观，不错过任何精彩片段。
            </p>
            <a
              href={`mailto:${brandEmail}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600"
            >
              <i className="ri-mail-line"></i>
              {brandEmail}
            </a>
          </div>

          {/* quick nav */}
          <nav aria-label="页脚导航">
            <h4 className="text-sm font-bold tracking-wide text-foreground-900">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {navItems.map((n) => (
                <li key={n.key}>
                  <a href={n.key} className="text-sm text-foreground-600 hover:text-primary-600">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* friend links */}
          <div>
            <h4 className="text-sm font-bold tracking-wide text-foreground-900">吃瓜推荐</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {friendLinks.map((f) => (
                <li key={f}>
                  <a href="#top" className="text-sm text-foreground-600 hover:text-primary-600">
                    {f}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-foreground-950/10 pt-6 sm:flex-row">
          <p className="text-center text-xs text-foreground-500">
            © {year} {brandName} · 娱乐资讯整理，仅供理性吃瓜参考
          </p>
          <p className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-heart-3-line text-accent-600"></i>
            跟紧大部队，蹲后续不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}